import { Capacitor } from '@capacitor/core'
import { PushNotifications } from '@capacitor/push-notifications'
import { useNavigate } from '@solidjs/router'

function extractPathFromAppUrl(appUrl: string): string {
	const match = appUrl.match(/^[\w+.-]+:\/\/(.+)$/)
	if (match?.[1]) {
		return `/${match[1].replace(/^\/+/, '')}` // ensure leading slash
	}
	return '/'
}

function mobile() {
	const navigate = useNavigate()
	try {
		PushNotifications.addListener('pushNotificationActionPerformed', (event) => {
			console.log('🔔 Push notification action performed:', event)
			const data = event.notification.data
			const appUrl = data?.app_url ?? event.notification.data?.launchURL

			console.log('Notification data:', data)

			if (appUrl) {
				try {
					const path = extractPathFromAppUrl(appUrl)
					console.log('📍 Navigating to:', path)
					navigate(path)
				} catch (err) {
					console.error('❌ Invalid deep link URL:', appUrl, err)
				}
			} else if (data?.route) {
				console.log('📍 Navigating to route:', data.route)
				navigate(data.route)
			} else {
				console.warn('⚠️ No app_url, launchURL, or route found in notification data')
			}
		})
	} catch (err) {
		console.error('❌ mobile push listener error:', err)
	}
}

export async function usePushEvents() {
	try {
		if (Capacitor.isNativePlatform()) {
			mobile()
		} else {
			// For Web, onMessage is handled in the foreground which might not need navigation
			// or can be added here if we want to handle background clicks via Service Worker
		}
	} catch (err) {
		console.error('❌ usePushEvents error:', err)
	}
}
